"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalForm = void 0;
const UI_1 = require("../UI");
function ModalForm(props) {
    const { useForm } = UI_1.useUIContext();
    return useForm(props);
}
exports.ModalForm = ModalForm;
//# sourceMappingURL=ModalForm.js.map